import { createUseStyles } from 'react-jss';

import { ITheme } from 'types';

const useStyles = createUseStyles((theme: ITheme) => ({
  undoRedoContainer: {
    display: 'inline-grid',
    gridAutoFlow: 'column',
    gap: 4,
    padding: theme.spacings.s4,
    background: '#ffffff',
    borderRadius: theme.variables.mainBorderRadius,
  },
  undoRedoIcon: {
    width: 34,
    height: 34,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#ffffff',
    borderRadius: theme.variables.mainBorderRadius,
    '&:not($active)': {
      pointerEvents: 'none',
    },
    '& path': {
      fill: '#dcdde9',
    },
  },
  active: {
    cursor: 'pointer',
    '& path': {
      fill: '#626777',
    },
    '@media(hover: hover)': {
      '&:hover': {
        backgroundColor: '#edeef499',
      },
    },
  },
  undoRedo: {
    width: theme.variables.iconSize,
    height: theme.variables.iconSize,
  },
}));

export default useStyles;
